import { render, staticRenderFns } from "./StatsFittingGoods.vue?vue&type=template&id=641fe507&"
import script from "./StatsFittingGoods.vue?vue&type=script&lang=js&"
export * from "./StatsFittingGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports